import { useEffect, useState } from "react";
import { Link, useLocation, useMatch } from "react-router-dom";
import { ReactComponent as IconArrow } from "../../../styles/assets/svg/icon_sidemenu_arrow.svg";
import { SidemenuList } from "../../molecules/SidemenuList";
import * as S from "./SidemenuItem.style";

interface MenuItem {
  id: number;
  title: string;
  icon?: React.ReactNode;
  depth: number;
  path?: string;
  mainPath?: string[];
  submenu?: MenuItem[];
}

interface SidemenuItemProps {
  data: any;
  onContextMenu: (event: React.MouseEvent, target: any) => void;
}
const matchPathPattern = (pattern: string, path: string): boolean => {
  const patternParts = pattern.split("/");
  const pathParts = path.split("/");

  if (patternParts.length !== pathParts.length) return false;

  return patternParts.every((part, index) => {
    if (part.startsWith(":")) return true;
    return part === pathParts[index];
  });
};

const isMenuActive = (menuItem: MenuItem, currentPath: string): boolean => {
  console.log(menuItem);
  // 기본 path 체크
  if (menuItem.path === currentPath) return true;

  // mainPath 배열 체크
  if (
    menuItem.mainPath?.some((matchPath) => {
      // 정확한 경로 매칭
      if (matchPath === currentPath) return true;

      // 와일드카드 매칭
      if (
        matchPath.endsWith("*") &&
        currentPath.startsWith(matchPath.slice(0, -1))
      )
        return true;

      // 동적 경로 매칭
      if (matchPath.includes(":") && matchPathPattern(matchPath, currentPath))
        return true;

      return false;
    })
  )
    return true;

  // submenu 재귀 체크
  if (menuItem.submenu?.some((subItem) => isMenuActive(subItem, currentPath)))
    return true;

  return false;
};

export const SidemenuItem = ({ data, onContextMenu }: SidemenuItemProps) => {
  const location = useLocation();
  const [submenu, setSubmenu] = useState(false);
  const [initialized, setInitialized] = useState(false);
  // useMatch 대신 isMenuActive 사용
  const isActive = isMenuActive(data, location.pathname);

  useEffect(() => {
    if (!initialized) {
      const openMenu = (menu: any, path: string) => {
        if (!menu.submenu) return false;
        for (const subItem of menu.submenu) {
          if (path.startsWith(subItem.path)) {
            return true;
          }
          if (subItem.submenu && openMenu(subItem, path)) {
            return true;
          }
        }
        return false;
      };
      // console.log("!!",data, location.pathname);
      if (openMenu(data, location.pathname)) {
        setSubmenu(true);
      }

      setInitialized(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, data]);

  const submenuToggle = () => {
    setSubmenu(!submenu);
  };

  return (
    <S.SidemenuItemBox
      $submenuToggle={submenu}
      $menuActive={isActive}
      onContextMenu={(e) => onContextMenu(e, data.path)}
    >
      {data.submenu ? (
        <>
          <S.SidemenuListItem
            $depth={data.depth}
            onClick={data.submenu && submenuToggle}
          >
            <S.SidemenuItemTit>
              {data.depth === 1 && data.icon}
              {data.depth !== 1 && "- "}
              <S.TitBox>{data.title}</S.TitBox>
            </S.SidemenuItemTit>
            {data.submenu && <IconArrow />}
          </S.SidemenuListItem>
          <SidemenuList
            depth={data.depth + 1}
            menuList={data.submenu}
            onContextMenu={onContextMenu}
          />
        </>
      ) : (
        <Link to={`${data.path}`}>
          <S.SidemenuListItem $depth={data.depth}>
            <S.SidemenuItemTit>
              {data.depth === 1 && data.icon}
              {data.depth !== 1 && "- "}
              <S.TitBox>{data.title}</S.TitBox>
            </S.SidemenuItemTit>
            {data.submenu && <IconArrow />}
          </S.SidemenuListItem>
        </Link>
      )}
    </S.SidemenuItemBox>
  );
};
